import { Currency, LegalEntityCountry } from '@seapoint/server/enums';
import { SupportedCountryCurrency } from '../types/supported-country-currency';
import { exhaustiveCheck } from './exhaustive-check';

export const getCountryCurrency = (country: LegalEntityCountry): SupportedCountryCurrency => {
  switch (country) {
    case LegalEntityCountry.GB:
      return Currency.GBP;
    case LegalEntityCountry.IE:
      return Currency.EUR;
    case LegalEntityCountry.DE:
      return Currency.EUR;
    default:
      return exhaustiveCheck(country);
  }
};
